import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon, ChevronLeftIcon } from 'lucide-react';
import { AkkoBadge, DistrictLogo } from '../components/BrandMark';
import { district } from '../data/district';
export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  return <div className="flex min-h-full w-full flex-col items-center justify-center bg-white px-4 py-12" data-id="element-497" data-mp="1xv4lwz4w8z3g">
      <div className="mb-8 flex flex-col items-center gap-2" data-id="element-498" data-mp="2qlmz4szc0gul">
        <DistrictLogo size="lg" data-id="element-499" data-mp="2qm4qbb7504vn" />
        <p className="text-[15px] font-bold text-ink-900" data-id="element-500" data-mp="2lmjs52zsk0jz">{district.name}</p>
        <AkkoBadge tone="light" data-id="element-501" data-mp="2lkp8rt464gi0" />
      </div>

      <div className="w-full max-w-md rounded-lg border border-ink-200 bg-white px-8 py-8 shadow-card" data-id="element-502" data-mp="2gnysp5sd5kwl">
        {sent ? <div className="text-center" data-id="element-503" data-mp="1a868kac2m79r">
            <CheckCircle2Icon className="mx-auto h-10 w-10 text-emerald-500" data-id="element-504" data-mp="1a50jgv3fz5e1" />
            <h1 className="mt-4 text-[16px] font-bold text-ink-900" data-id="element-505" data-mp="156yyu5qday0g">Check your email</h1>
            <p className="mt-2 text-[13px] text-ink-500" data-id="element-506" data-mp="346is87x0ea05">
              If an account exists for <span className="font-semibold text-ink-700" data-id="element-507" data-mp="386krkaf9urc9">{email}</span>, we&apos;ve
              sent a link to reset your password. The link expires in 30 minutes.
            </p>
          </div> : <>
            <h1 className="text-[16px] font-bold text-ink-900" data-id="element-508" data-mp="2z5376fuu03hr">Reset your password</h1>
            <p className="mt-1 text-[13px] text-ink-500" data-id="element-509" data-mp="2kggsmgd13frl">
              Enter the email tied to your district account and we&apos;ll send you a reset link.
            </p>
            <form onSubmit={e => {
          e.preventDefault();
          if (email.trim()) setSent(true);
        }} className="mt-6" data-id="element-510" data-mp="2bi4u7s5x7dol">
              <label htmlFor="email" className="block text-[14px] text-ink-800" data-id="element-511" data-mp="21iw274um894v">
                Work email
              </label>
              <input id="email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@bcsd.org" className="mt-2 h-11 w-full rounded border border-ink-300 px-3 text-[14px] text-ink-900 placeholder:text-ink-400 focus:border-brand-500 focus:outline-none" data-id="element-512" data-mp="26hqwb2y19k4a" />
              <button type="submit" className="mt-5 h-11 w-full rounded bg-brand-600 text-[15px] font-bold text-white transition-colors hover:bg-brand-700" data-id="element-513" data-mp="26chrgq3tflkf">
                Send reset link
              </button>
            </form>
          </>}

        <p className="mt-6 text-center" data-id="element-514" data-mp="1rf8y5quyc7q2">
          <Link to="/" className="inline-flex items-center gap-1 text-[13px] text-ink-800 underline-offset-2 hover:underline" data-id="element-515" data-mp="1re7b0o0nvurz">
            <ChevronLeftIcon className="h-4 w-4" data-id="element-516" data-mp="g0269ssmjgvl" />
            Back to sign in
          </Link>
        </p>
      </div>
    </div>;
}